import React from 'react'
import { Box } from '@mui/material'
import { pointText } from '../../../lib/rule'

const PlayerSpecial = ({ simple, rule, label }) => {
  const pt = pointText(simple)

  const point = value => (
    <>
      <Box component="span" className="rule-point-batsu-value">
        {value}
      </Box>
      <Box component="span" className="rule-point-batsu-unit">
        {pt}
      </Box>
    </>
  )

  const list = [(
    rule.winPoint.active && rule.specialCorrect.passQuiz &&
    <Box component="span" className="rule-content" key="special-pass-quiz">
      通過席で誤答または他の人が正解で{point(rule.initPoint)}に戻る
    </Box>
  ), (
    rule.specialWrong.divide &&
    <Box component="span" className="rule-content" key="special-divide">
      ポイントの小数点以下は切り捨て
    </Box>
  )].filter(e => e)

  return list.length > 0 && (
    <Box component="span" className="rule-element">
      <Box component="span" className="rule-title">{label || 'その他'}</Box>
      {list}
    </Box>
  )
}

export default PlayerSpecial
